var index = {
  root: {
    background: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    height: '1.25rem'
  },
  value: {
    background: '{primary.color}'
  },
  label: {
    color: '{primary.contrast.color}',
    fontSize: '0.75rem',
    fontWeight: '600'
  }
};

export { index as default };
//# sourceMappingURL=index.mjs.map
